import { createFormState, required } from "redux-freeform";

const formState = {
  captchaToken: {
    validators: [required()]
  },
  // The captcha provider is used to determine which captcha service to use
  // Temporarily not required and no default value provided to support feature flagging during Wallet Cloudflare Turnstile integration
  // Eventually this can be required with a default value of "TURNSTILE"
  captchaProvider: {}
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formState
);
